<template>
	<div class="news mt-lg-5" id="news">
		<div class="container news-bg" v-if="!$route.meta.child">
			<div class="row">
				<div class="col-12">
					<h1 class="text-center mb-3 mb-lg-5">Aktualności</h1>
				</div>
			</div>
			<div class="row mb-5" v-for="entry in entries" :key="entry.slug">
				<div class="col-12 col-sm-6 offset-sm-2 offset-lg-0 col-lg-3 offset-lg-2">
					<div class="news-list__image" :style="{'background-image': 'url('+entry.image+')'}"></div>
				</div>
				<div class="col-12 col-lg-5 d-flex align-items-start justify-content-center flex-column">
					<h6 class="text-gray">
						{{ entry.date }}
					</h6>
					<h4>
						{{ entry.title }}
					</h4>
					<router-link :to="'/news/'+entry.slug" @click.native="scrollToTop" class="fw-500 text-gradient link-underline">Przeczytaj artykuł</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default{
	data() {
		return {
			entries: null,
			recentEntry: null
		}
	},
	mounted() {
		axios.get("https://ango.waw.pl/markdowns/news.json")
			.then(
				resp => {
					this.entries = resp.data;
					this.recent();
				}
			)

	},
	methods: { 
		scrollToTop() {
			window.scrollTo(0,0);
		},
		recent() {
			let i = 0,
				count = true;
			for(i=0;i<this.entries.length; i++){
				if(this.$route.meta.slug !== this.entries[i].slug && count){
					this.recentEntry = this.entries[i];
					count = false;
				}
			}
		}
	}
}
</script>

<style lang="scss">
	.back-link{
		color: black;
		&:hover{
			color: black;
		}
	}
	.news {
		img{
			max-width: 100%;
			margin-top: 25px;
			margin-bottom: 25px;
		}
		h2{
			text-align: center;
		}
		h1,h2,h3,h4,h5,h6, .h1,.h2,.h3,.h4,.h5,.h6{
			margin-bottom: 25px;
		}
		p{
			margin-bottom: 1.5rem;
		}
	}
	.news-list__image{
		border-radius: 200px 0 200px 200px;
		position: relative;
		background-color: #666666; 
		background-position: center;
		background-size: cover; 
		&:after{
			display: block;
			content: '';
			padding-bottom: 100%;
		}
	}
</style>